var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-color-picker',{attrs:{"predefine":_vm.predefineColors},on:{"change":_vm.handleChange},model:{value:(_vm.colorValue),callback:function ($$v) {_vm.colorValue=$$v},expression:"colorValue"}}),_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v(_vm._s(_vm.colorValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }